import { useEffect, useState } from "react";
import {
  Container,
  Checkbox,
  FormControlLabel,
  FormControl,
  FormLabel,
  RadioGroup,
  Radio,
} from "@mui/material";
import useStore from "../store/store";
import transactionService from "../services/transaction";
import {
  Text,
  Heading,
  Button,
  StockDropDown,
  AccountsDropdown,
  FormatNumeric,
  FormatCurrency,
  ArrowDownChip,
} from "../controls";

function AddTransaction({
  toggleDrawer,
  reload,
  isCredit,
  isDebit,
  setIsDebit,
  setIsCredit,
}) {
  let [from, setFrom] = useState({});
  let [to, setTo] = useState({});
  let [amount, setAmount] = useState("");
  let [note, setNote] = useState("");
  let [bol, setBol] = useState(false);
  let [type, setType] = useState("purchase");
  let [stock, setStock] = useState({});
  let [quantity, setQuantity] = useState("");

  const {
    token,
    setErrorMessage,
    setSuccessMessage,
    setIsLoading,
    currObj,
    setCurrObj,
    setToEdit,
  } = useStore((state) => state);

  useEffect(() => {
    if (currObj) {
      setFrom({ lable: currObj.fromName, value: currObj.fromId });
      setTo({ lable: currObj.toName, value: currObj.toId });
      setAmount(currObj.amount);
      setNote(currObj.note);
      if (currObj.stockId) {
        setBol(true);
        setStock({ value: currObj.stockId, label: currObj.stockName });
        setQuantity(currObj.quantity);
      }
    }
  }, []);

  const createTransaction = (more) => {
    setIsLoading(true);
    if (from.value === to.value) {
      setErrorMessage("Debit and Credit accounts can not be same.");
      setIsLoading(false);
      return;
    }
    if (isCredit && !isDebit) credit(more);
    if (isDebit && !isCredit) debit(more);
    if (isCredit && isDebit) create(more);
  };

  const create = (more) => {
    quantity = type === "purchase" ? quantity : -quantity;
    let data = {
      fromId: from.value,
      fromName: from.label,
      toId: to.value,
      toName: to.label,
      amount,
      note,
      stockId: bol ? stock.value : "",
      stockName: bol ? stock.label : "",
      quantity: bol ? quantity : "",
    };
    transactionService.create(token, data).then((r) => {
      if (r.error) {
        setErrorMessage(r.error);
        setIsLoading(false);
        return;
      }
      if (r.data) {
        setSuccessMessage("Transaction created successfully");
        clearForm(more);
      }
    });
  };

  const debit = (more) => {
    quantity = type === "purchase" ? quantity : -quantity;
    let data = {
      fromId: from.value,
      fromName: from.label,
      amount,
      note,
      stockId: bol ? stock.value : "",
      stockName: bol ? stock.label : "",
      quantity: bol ? quantity : "",
    };
    transactionService.debit(token, data).then((r) => {
      if (r.error) {
        setErrorMessage(r.error);
        setIsLoading();
        return;
      }
      if (r.data) {
        setSuccessMessage("Transaction created successfully");
        clearForm(more);
      }
    });
  };

  const credit = (more) => {
    quantity = type === "purchase" ? quantity : -quantity;
    let data = {
      toId: to.value,
      toName: to.label,
      amount,
      note,
      stockId: bol ? stock.value : "",
      stockName: bol ? stock.label : "",
      quantity: bol ? quantity : "",
    };
    transactionService.credit(token, data).then((r) => {
      if (r.error) {
        setErrorMessage(r.error);
        setIsLoading(false);
        return;
      }
      if (r.data) {
        setSuccessMessage("Transaction created successfully");
        clearForm(more);
      }
    });
  };

  const clearForm = (more) => {
    more = more ? more : false;
    setFrom({});
    setTo({});
    setAmount("");
    setNote("");
    setBol(false);
    setStock({});
    setQuantity("");
    setIsLoading(false);
    reload();

    if (more === false) {
      setIsCredit(false);
      setIsDebit(false);
      setToEdit(false);
      setCurrObj(null);
      toggleDrawer();
    }
  };

  return (
    <>
      <Container sx={{ overflow: "auto" }}>
        <Heading text="Add Transaction" variant="h6" />
        {isCredit && (
          <AccountsDropdown
            label={currObj ? currObj.toName : "Credit / جمع"}
            value={currObj ? currObj.toId : to.value}
            onChange={setTo}
          />
        )}
        {isDebit && (
          <AccountsDropdown
            label={currObj ? currObj.fromName : "Debit / بنام"}
            value={currObj ? currObj.fromId : from.value}
            onChange={setFrom}
          />
        )}
        <FormatCurrency label="Amount" value={amount} onChange={setAmount} />
        <Text label="Note (Optional)" value={note} onChange={setNote} />
        <FormControlLabel
          control={
            <Checkbox
              checked={bol}
              onChange={(e) => setBol(e.target.checked)}
              name="gilad"
            />
          }
          label="Its related to stocks"
        />
        <br />
        {bol && (
          <FormControl>
            <RadioGroup
              aria-labelledby="radio"
              defaultValue="purchase"
              name="radio-buttons-group"
              value={type}
              onChange={(e) => setType(e.target.value)}
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <FormLabel id="radio" sx={{ mr: 2 }}>
                Type
              </FormLabel>
              <FormControlLabel
                value="purchase"
                control={<Radio />}
                label="Purchase"
              />
              <FormControlLabel value="sale" control={<Radio />} label="Sale" />
            </RadioGroup>
          </FormControl>
        )}
        {bol && (
          <StockDropDown
            label={currObj ? currObj.stockName : "Stock"}
            value={currObj ? currObj.stockId : stock.value}
            onChange={setStock}
          />
        )}
        {bol && (
          <FormatNumeric
            label="Quantity"
            value={quantity}
            onChange={setQuantity}
          />
        )}
        <Button
          icon={<ion-icon name="add-circle-outline"></ion-icon>}
          onClick={() => {
            createTransaction(false);
          }}
          text="Create"
        />
        <Button
          icon={<ion-icon name="add-circle-outline"></ion-icon>}
          onClick={() => {
            createTransaction(true);
          }}
          text="Create & add more"
          extraStyles={{ marginTop: 5 }}
        />
        <ArrowDownChip onClick={clearForm} />
      </Container>
    </>
  );
}

export default AddTransaction;
